module.exports = __webpack_public_path__ + "static/projekt_indywidualny_b7-b513220e1adf3d05636eb6bd1e87b3fc.jpg";